import { render, staticRenderFns } from "./content.component.vue?vue&type=template&id=3bf1261d"
import script from "./content.component.vue?vue&type=script&lang=js"
export * from "./content.component.vue?vue&type=script&lang=js"
import style0 from "./content.component.vue?vue&type=style&index=0&id=3bf1261d&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports